import ManagementDashboardApp from "../../components/ManagementDashboardApp/ManagementDashboardApp";
import { DashboardManagementStyle } from "./DashboardManagementStyle";

export const DashboardManagement = () => {
  return (
    <DashboardManagementStyle>
      <ManagementDashboardApp
        pathName1_1="/dashboard/crm/reporting/tradinglist"
        pathName1_2="/dashboard/crm/reporting/tradinglist"
        pathName1_3="/dashboard/crm/reporting/tradinglist"
        pathName1_4="/dashboard/crm/reporting/tradinglist"
        pathName2_1="/dashboard/crm/advancedsearch"
        pathName2_2="/dashboard/crm/advancedsearch"
        pathName2_3="/dashboard/crm/advancedsearch"
        pathName2_4="/dashboard/crm/advancedsearch"
        pathName3_1="/dashboard/crm/reporting/UsersList"
        pathName3_2="/dashboard/crm/reporting/UsersList"
        pathName3_3="/dashboard/crm/reporting/UsersList"
        pathName3_4="/dashboard/crm/reporting/UsersList"
      />
    </DashboardManagementStyle>
  );
};
